import { ListItem, TableCell } from '@mui/material';
import CellList from './CellList';

const DeliveryMethodCell = ({ session }) => {
  const methods = session?.delivery_method ?? [];

  return (
    <TableCell align="left">
      {methods.length > 1 && (
        <CellList>
          {methods.map((method, i) => (
            <ListItem key={`method-${i}`} disableGutters>{method}</ListItem>
          ))}
        </CellList>
      )}
      {methods.length === 1 && methods[0]}
    </TableCell>
  );
};

export default DeliveryMethodCell;
